export var TableCssClass;
(function (TableCssClass) {
    TableCssClass["Base"] = "iress-table";
    TableCssClass["Table"] = "iress-table__table";
    TableCssClass["Caption"] = "iress-table__caption";
    TableCssClass["Hover"] = "iress-table--hover";
    TableCssClass["Header"] = "iress-table__header";
    TableCssClass["HeaderSortable"] = "iress-table__header--sortable";
    TableCssClass["Empty"] = "iress-table__cell--empty";
    TableCssClass["Column"] = "iress-table__col";
    TableCssClass["Cell"] = "iress-table__cell";
    TableCssClass["CellDivider"] = "iress-table__cell--divider";
    TableCssClass["CellSpan"] = "iress-table__cell-span";
    TableCssClass["Row"] = "iress-table__row";
    TableCssClass["RowHeader"] = "iress-table__row--header";
    TableCssClass["RowEven"] = "iress-table__row--even";
    TableCssClass["SortButton"] = "iress-table__sort-button";
    TableCssClass["SortIcon"] = "iress-table__sort-icon";
    TableCssClass["VrtHover"] = "iress-table--vrt-hover";
})(TableCssClass || (TableCssClass = {}));
export var TableColumnAlign;
(function (TableColumnAlign) {
    TableColumnAlign["Left"] = "left";
    TableColumnAlign["Right"] = "right";
    TableColumnAlign["Center"] = "center";
})(TableColumnAlign || (TableColumnAlign = {}));
export var TableCellFormat;
(function (TableCellFormat) {
    TableCellFormat["String"] = "string";
    TableCellFormat["Number"] = "number";
    TableCellFormat["Date"] = "date";
    TableCellFormat["Currency"] = "currency";
    TableCellFormat["Percent"] = "percent";
})(TableCellFormat || (TableCellFormat = {}));
export var TableSortOrder;
(function (TableSortOrder) {
    TableSortOrder["Asc"] = "ascending";
    TableSortOrder["Desc"] = "descending";
})(TableSortOrder || (TableSortOrder = {}));
export var TableScope;
(function (TableScope) {
    TableScope["Row"] = "row";
    TableScope["Col"] = "col";
})(TableScope || (TableScope = {}));
export var TableSlot;
(function (TableSlot) {
    TableSlot["Empty"] = "empty";
})(TableSlot || (TableSlot = {}));
//# sourceMappingURL=table.types.js.map